<template>
  <div id="allbots">
    <div id="main">
      <!-- $store.state.userid -->
      <v-snackbar v-model="showCopy" :timeout="6000" color="green" :top="true"
        >{{ $t('Link Copied') }}!</v-snackbar
      >
      <div>
        <div>
          <div
            style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; height: 100%; background: transparent linear-gradient(40deg, rgb(235, 181, 33) 0%, rgb(247, 67, 154) 100%) 0% 0% no-repeat padding-box;
opacity: 0.8;"
          >
            <!-- <vue-particles
              color="#ffffff"
              :particleOpacity="0.27"
              :particlesNumber="24"
              shapeType="circle"
              :particleSize="3"
              linesColor="#ffffff"
              :linesWidth="1.1"
              :lineLinked="true"
              :lineOpacity="0.33"
              :linesDistance="192"
              :moveSpeed="1.6"
              :hoverEffect="false"
              :clickEffect="false"
            ></vue-particles> -->
          </div>
          <div class="accounts" v-show="!isLoading" style="z-index: 2">
            <v-toolbar flat color="transparent" style="background: transparent">
              <v-toolbar-title>
                <img
                  :src="$store.state.theme.small_logo"
                  class="responsive-img"
                  style="max-height:25px; margin-top: 15px; margin-left: 20px"
                  alt
                />
              </v-toolbar-title>

              <v-spacer></v-spacer>
              <div class="form-control" v-if="$store.state.userid == 'zwizadmin'">
                <div class="hidden-xs-only">
                  <v-layout>
                    <input
                      @blur="onSearch"
                      type="text"
                      v-model="search"
                      :placeholder="$t('Search')"
                      class="mb-0 pa-1"
                      style="line-height: 21px"
                      :disabled="loading"
                      @keyup.enter="$refs.searchbtn.$el.click()"
                    />
                    <v-btn
                      ref="searchbtn"
                      small
                      fab
                      depressed
                      color="primary"
                      @click="onSearch"
                      :loading="loading"
                    >
                      <v-icon small>search</v-icon>
                    </v-btn>
                  </v-layout>
                </div>
                <div class="hidden-sm-and-up">
                  <v-btn small fab depressed color="primary" @click="showSearch = true">
                    <v-icon small>search</v-icon>
                  </v-btn>
                  <v-dialog v-model="showSearch" max-width="600">
                    <v-card>
                      <div class="text-xs-right">
                        <v-btn small fab flat @click="showSearch = false"
                          ><v-icon>close</v-icon></v-btn
                        >
                      </div>
                      <v-card-text>
                        <div class="form-control">
                          <input
                            @blur="onSearch"
                            type="text"
                            v-model="search"
                            :placeholder="$t('Search')"
                            class="mb-0 pa-1"
                            style="line-height: 21px"
                            :disabled="loading"
                          />
                        </div>
                        <div class="text-xs-center">
                          <v-btn depressed color="primary" @click="onSearch" :loading="loading">
                            <v-icon small>search</v-icon> {{ $t('Search') }}
                          </v-btn>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                </div>
              </div>
              <change-password></change-password>

              <!-- <router-link
                :to="'/' + $i18n.locale() + '/partner'"
                class="link link-white"
                style="font-size: 18px; "
                v-if="$store.state.partner_code"
              >
                <v-btn depressed color="green" dark style="line-height: 10px;">
                  <v-icon class="mr-2" small>stars</v-icon>Partner Portal
                </v-btn>
              </router-link> -->

              <v-btn
                flat
                fab
                icon
                small
                @click="logout"
                class="hidden-sm-and-up"
                style="line-height: 10px;"
              >
                <v-icon>power_settings_new</v-icon>
              </v-btn>
              <v-btn
                flat
                class="primary hidden-xs-only mr-4"
                style="line-height: 10px;"
                @click="logout"
                >{{ $t('Sign Out') }}</v-btn
              >
              <lang-dropdown></lang-dropdown>
            </v-toolbar>

            <div class="text-xs-center">
              <h2 class=" mt-4" style="color: white; font-size: 40px;">
                {{ $t('Select bot to manage') }}
              </h2>
            </div>

            <v-container>
              <!--               <div class="text-xs-center" v-if="botlist.length >= size ">
                <v-pagination
                  v-model="pageNumber"
                  :length="pageCount"
                  @input="onClickPageinate"
                  class="mb-2"
                ></v-pagination>
              </div>-->
              <v-layout
                wrap
                justify-center
                fill-height
                class="select-page"
                style="position:relative; margin-bottom: 35px;"
                :class="{ 'no-bot': !botlist || botlist.length == 0 }"
              >
                <template v-for="bot in filterBots">
                  <v-flex
                    xs6
                    sm4
                    md3
                    lg2
                    class="page pa-3"
                    :key="'bot_' + bot.pageid"
                    style="cursor: pointer; position:relative"
                  >
                    <SocialBadge :value="bot.packages"></SocialBadge>
                    <v-responsive
                      :aspect-ratio="1 / 1"
                      class="page-image"
                      @click="onSelectedBot(bot)"
                    >
                      <tag-allbot :bot="bot"></tag-allbot>
                      <!-- <div
                        class="expireat"
                        :style="'background: red;'"
                        v-if="
                          countDate(bot.expireat) < 8 &&
                            countDate(bot.expireat) > 0 &&
                            bot.advanced_expireat &&
                            countDate(bot.advanced_expireat) < 8 &&
                            countDate(bot.advanced_expireat) > 0
                        "
                      >
                        <span
                          >{{ $t('package_remain') }} {{ countDate(bot.expireat) }}
                          {{ $t('day(s)') }}</span
                        >
                      </div>
                      <div
                        class="expireat"
                        :style="'background: gray;'"
                        v-if="!bot.advanced_expireat && bot.expireat === bot.registerat"
                      >
                        <span>{{ $t('basic_package_free') }}</span>
                      </div>
                      <template v-else>
                        <div
                          class="expireat"
                          :style="'background: gray;'"
                          v-if="
                            bot.expireat &&
                              countDate(bot.expireat) === 0 &&
                              bot.advanced_expireat &&
                              countDate(bot.advanced_expireat) === 0
                          "
                        >
                          <span>{{ $t('package_expired') }}</span>
                        </div>
                      </template> -->
                      <img
                        @error="imgError"
                        :src="
                          bot.pagelogo ||
                            'https://graph.facebook.com/' +
                              bot.pageid +
                              '/picture?width=300&height=300&SameSite=None'
                        "
                        :alt="bot.pagename"
                        :title="bot.pagename"
                        style="width: 100%;border-radius: 10px 10px 10px 0px;"
                      />
                    </v-responsive>
                    <div
                      class="page-name text-xs-center white--text mt-2 mb-2 text-truncate"
                      :title="bot.pagename"
                      @click="onSelectedBot(bot)"
                    >
                      {{ bot.pagename }}
                    </div>
                    <v-btn
                      fab
                      color="primary"
                      depressed
                      small
                      class="extra-small"
                      style="position:absolute; left: 0; top: 0"
                      v-clipboard:copy="bot.pageid"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                      v-if="$store.state.userid == 'zwizadmin'"
                    >
                      <v-icon>file_copy</v-icon>
                    </v-btn>
                  </v-flex>
                </template>
                <v-dialog
                  v-model="isAdd"
                  fullscreen
                  hide-overlay
                  transition="dialog-bottom-transition"
                >
                  <template v-slot:activator="{ on }">
                    <v-flex
                      xs6
                      sm4
                      md3
                      lg2
                      class="page pa-3"
                      v-if="isFacebook"
                      v-on="on"
                      style="cursor: pointer"
                    >
                      <!-- <div class="btn-add-page">
                          <h1 style="color: white;margin-top: 60px">
                            <i class="fas fa-plus"></i>
                          </h1>
                      </div>-->
                      <v-responsive aspect-ratio="1:1">
                        <vue-simple-svg
                          :filepath="'/static/img/assets/_global/page-plus.svg'"
                          style="min-width: 100%;"
                          height="auto"
                          fill="white"
                          class="page-image"
                        />
                      </v-responsive>

                      <div class="page-name text-xs-center white--text mt-2 mb-2">
                        {{ $t('Add') }}
                      </div>
                    </v-flex>
                  </template>

                  <v-card>
                    <template v-if="$store.state.isLoggedIn">
                      <div id="get-started">
                        <get-started @close="isAdd = false"></get-started>
                      </div>
                    </template>
                  </v-card>
                </v-dialog>
              </v-layout>
              <!-- {{botlist}} -->
              <v-btn
                :loading="loading"
                :disabled="loading"
                @click="getMore"
                v-if="
                  $store.state.userid &&
                    $store.state.userid.includes('zwiz') &&
                    filterBots &&
                    filterBots.length >= 100
                "
                x-large
                block
                outline
                color="white"
                >MORE</v-btn
              >
              <!--               <div class="text-xs-center" v-if="botlist.length >= size">
                <v-pagination
                  v-model="pageNumber"
                  :length="pageCount"
                  @input="onClickPageinate"
                  class="mb-2"
                ></v-pagination>
              </div>-->
            </v-container>
          </div>
        </div>
      </div>
    </div>

    <v-dialog scrollable v-model="showSupport" max-width="600" persistent>
      <v-card>
        <div class="text-xs-center pa-2 pt-3">
          <div class="title primary--text">{{ $t('You want to use a Redeem Code') }}</div>
          <div
            class="pa-2 my-2 mx-auto"
            style="background: #eee; border-radius: 50px; max-width: 400px"
          >
            {{ supportcode }}
          </div>
          {{ $t('with page') }}
        </div>
        <v-divider />
        <v-card-text max-height="600">
          <template v-for="(bot, index) in botlist">
            <div :key="bot.pageid" class="pa-2">
              <v-layout>
                <v-avatar :size="50">
                  <img
                    :src="
                      bot.pagelogo ||
                        'https://graph.facebook.com/' +
                          bot.pageid +
                          '/picture?width=100&height=100&SameSite=None'
                    "
                  />
                </v-avatar>
                <v-flex class="pa-2">{{ bot.pagename }}</v-flex>
                <v-btn
                  color="primary"
                  :loading="loadingSupport"
                  small
                  depressed
                  @click="useRedeemCode(bot.pageid)"
                  >{{ $t('Apply') }}</v-btn
                >
              </v-layout>
            </div>
            <v-divider :key="bot.pageid + '_divider'" v-if="botlist.length - 1 != index" />
          </template>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            flat
            @click="
              showSupport = false
              clearSupportCode()
            "
            :loading="loadingSupport"
            >{{ $t("I don't want to use it for now") }}</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import api from '@/api'
import config from '@/config'
import dayjs from 'dayjs'

import GetStarted from '@/components/view/getstarted/GetStarted'
import LangDropdown from '@/components/elements/LangDropdown'
import ChangePassword from './ChangePassword.vue'
import SocialBadge from '@/components/elements/SocialBadge'
import TagAllbot from './TagAllbot.vue'

export default {
  data: function() {
    return {
      pageNumber: 1,
      size: 60,
      pagelist: this.$store.state.pagelist,
      isLoading: true,
      isAdd: false,
      themelist: [],
      search: '',
      botCount: 0,
      showCopy: false,
      loading: false,
      botFound: [],
      showSupport: false,
      supportcode: '',
      loadingSupport: false,
      loadingSearch: false,
      showSearch: false
    }
  },
  components: {
    GetStarted,
    LangDropdown,
    ChangePassword,
    SocialBadge,
    TagAllbot
  },
  async mounted() {
    let vm = this
    vm.$store.dispatch('loading')

    if (this.$route.query.supportcode) this.supportcode = this.$route.query.supportcode

    // await vm.getAllPublicTheme()
    if (vm.$store.state.facebook_info && !vm.$store.state.isFacebook)
      vm.$store.dispatch('updatePagelist')

    if (vm.$store.state.facebook_info || vm.$store.state.line_info) {
      let pageidlist = []
      let data = {}
      if (vm.$store.state.facebook_info) {
        try {
          pageidlist = vm.pagelist.filter(el => el != null)
        } catch (error) {
          vm.pagelist = []
        }
        data = {
          userid: vm.$store.state.userid,
          pageidlist: pageidlist,
          access_token: vm.$store.state.fbAccessToken
        }
      } else if (vm.$store.state.line_info) {
        try {
          pageidlist = vm.pagelist.map(el => el.id)
        } catch (error) {
          pageidlist = []
        }
        data = {
          userid: vm.$store.state.userid,
          pageidlist: pageidlist,
          access_type: 'LINE_MODULAR'
        }
      }
      try {
        let response = null

        if (vm.$store.state.isFacebook === true) {
          // response = await vm.$store.dispatch('getBotlist', data)
          // await vm.$store.dispatch('updateAccountDetail', response)
        }

        if (!vm.botlist || vm.botlist.length <= 0) {
          vm.isAdd = true
        } else {
          if (vm.$route.query.supportcode) {
            vm.showSupport = true
          }
        }
      } catch (error) {
        console.error(error)
        await this.$swal.fire({
          title: this.$t('Something went wrong'),
          type: 'warning',
          confirmButtonText: this.$t('Confirm'),
          reverseButtons: true
        })
      }
    } else {
      if (!vm.botlist || vm.botlist.length <= 0) {
        vm.isAdd = true
      }
    }

    if (this.$route.query.pageid) {
      try {
        let bot = this.botlist.find(el => {
          return el.pageid == this.$route.query.pageid
        })
        if (bot) {
          this.onSelectedBot(bot)
        }
      } catch (error) {}
    }
    this.isLoading = false
    this.$store.commit('CLEAR_LOADING')
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist',
      isFacebook: 'isFacebook',
      currentLang: 'currentLang'
    }),
    filterBots() {
      let bots = []
      if (this.search.length && this.botFound.length) {
        bots = this.botFound
      } else {
        bots = this.botlist
      }
      bots.sort((a, b) => {
        return ('' + a.pagename).localeCompare(b.pagename)
      })
      return bots
    },
    // filterBots: function() {
    //   let vm = this

    //   var b = []
    //   if (vm.search === '') {
    //     b = vm.botlist
    //   } else {
    //     b = vm.botlist.filter(bot => {
    //       return (
    //         bot.pagename.toLowerCase().includes(vm.search.toLowerCase()) ||
    //         bot.pageid.includes(vm.search.toLowerCase())
    //       )
    //     })
    //   }

    //   this.botCount = b.length

    //   const start = (this.pageNumber - 1) * this.size
    //   const end = start + this.size
    //   return b.slice(start, end)
    // },
    pageCount: function() {
      let l = this.botCount
      let s = this.size
      return Math.ceil(l / s)
    }
  },
  methods: {
    countDate(expireat) {
      let a = dayjs(expireat)
      let b = dayjs()
      return a.diff(b, 'days') > 0 ? a.diff(b, 'days') : 0
    },
    async useRedeemCode(pageid) {
      this.loadingSupport = true
      try {
        var response = await this.onSaveRedeem(pageid, this.supportcode)
        // console.log(response)
        var day = parseInt(response.extend)
        var latest_date = dayjs(response.expireat)
        response.package = response.isPass ? response.code : '-'

        if (response.responsecode == 200 && response.isPass) {
          await this.$swal.fire({
            type: 'success',
            title: this.$t('you got {day} days Premium Package', {
              day: day
            }),
            text: `${this.$t('Expired Date')} ${latest_date.format('DD/MM/YYYY')}`
          })
          this.clearSupportCode()
          location.reload()
        } else if (
          response.responsecode == 401 ||
          (response.responsecode == 200 && !response.isPass)
        ) {
          let time = response.unlocktimestamp
          await this.$swal.fire({
            type: 'error',
            title: this.$t('This page has too many attempt'),
            text: this.$t(`Please try again after`) + ' ' + dayjs(time).format('DD/MM/YYYY HH:mm')
          })
          this.$localStorage.set('redeemlock', time)
          this.clearSupportCode()
          this.showSupport = false
        } else {
        }
      } catch (error) {
        console.log(error)
      }
      this.loadingSupport = false
    },
    onSaveRedeem(pageid, code) {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = { pageid: pageid, redeem: code.toUpperCase() }
        api.activateredeemcode(data, function(error, response) {
          if (response.responsecode == 200) {
            if (response.hasOwnProperty('extend')) {
              response.isPass = true
              response.code = code
              resolve(response)
            } else {
              response.isPass = false
              response.code = code
              resolve(response)
            }
          } else if (response.responsecode == 401) {
            response.isPass = false
            response.code = code
            resolve(response)
          }
        })
      })
    },
    clearSupportCode() {
      // remove support code
      var query = { ...this.$route.query }
      delete query.supportcode
      this.$router
        .push({
          path: '/' + this.currentLang + '/allbots',
          query: query
        })
        .catch(() => {})
    },
    onSearch() {
      let vm = this
      let data = { limit: 100, offset: 0, pagename: vm.search.toLowerCase() }
      vm.loading = true

      api.zwizadminbotlist(data, (err, response) => {
        vm.botFound = response.botlist
        vm.loading = false
        vm.showSearch = false
        vm.$store.commit('SET_BOTLIST', vm.botFound)
      })
    },
    getMore() {
      let vm = this
      let data = { limit: 100, offset: vm.botlist.length }
      vm.loading = true

      api.zwizadminbotlist(data, (err, response) => {
        vm.loading = false
        vm.botlist.push(...response.botlist)
        vm.$store.commit('SET_BOTLIST', vm.botlist)
      })
    },
    onCopy: function() {
      let vm = this
      vm.showCopy = true
      setTimeout(() => {
        vm.showCopy = false
      }, 1000)
    },
    onError: function() {},
    onClickPageinate: function(pageNum) {
      this.pageNumber = pageNum
      $('html, body').animate({
        scrollTop: 0
      })
    },

    onSelectedBot: function(bot) {
      // if (this.$aston.astonpages.includes(bot.pageid)) {
      //   this.$swal.fire({
      //     title: 'ขณะระบบกำลังอยู่ระหว่างการปรับปรุง',
      //     type: 'warning',
      //     confirmButtonText: this.$t('Confirm'),
      //     showCancelButton: false,
      //     reverseButtons: true,
      //     footer: this.$t('เมื่อแก้ไขเสร็จเรียบร้อยจะแจ้งให้ทราบ')
      //   })
      //   return false
      // }
      this.$store.dispatch('selectBot', bot)
      if (this.$store.state.menubypageid[this.selectedBot.pageid]) {
        this.$router
          .push(this.$store.state.menubypageid[this.selectedBot.pageid][0])
          .catch(() => {})
      } else {
        if (
          this.$store.state.centralPage.includes(this.selectedBot.pageid) &&
          this.$store.state.privilege.role === 'admin' &&
          this.$store.state.loginChannel === 'account'
        ) {
          this.$router
            .push({
              path: '/' + this.currentLang + '/template',
              query: { tab: 'ecommerce-order-summary' }
            })
            .catch(() => {})
        } else {
          this.$router.push('home').catch(() => {})
        }
      }
    },
    logout: function() {
      var vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to Logout?'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            var isFacebook = vm.isFacebook
            if (isFacebook) {
              vm.$router.push('/' + vm.currentLang + '/login').catch(() => {})
            } else {
              if (vm.$store.state.privilege.role === 'admin') {
                vm.$router.push('/' + vm.currentLang + '/iconkaset').catch(() => {})
              } else if (vm.$store.state.userid === 'metateam') {
                vm.$router.push('/' + vm.currentLang + '/meta').catch(() => {})
              } else {
                vm.$router.push('/' + vm.currentLang + '/nigol').catch(() => {})
              }
            }
            vm.$store.dispatch('logout', null).then()
          }
        })
    },
    getAllPublicTheme() {
      let vm = this
      return new Promise((resolve, reject) => {
        api.getAllPublicTheme({ appid: config.appid }, function(error, response) {
          if (error) {
            reject(error)
          }

          vm.themelist = response.data
          resolve()
        })
      })
    },
    selectBot: function(pageid, event) {
      const bot = this.botlist.find(bot => {
        return bot.pageid == pageid
      })
      this.$store.dispatch('selectBot', bot)
    },
    imgError: function(event) {
      $(event.target).attr('src', '/static/img/assets/livechat/profile.png')
      // this.value.profile_pic = '/static/img/assets/livechat/profile.png'
    }
  },
  watch: {
    search: function(newVal, oldVal) {
      if (newVal && !newVal.length) this.botFound = []
      if (newVal !== oldVal) {
        this.pageNumber = 1
      }
    }
  }
}
</script>

<style lang="scss">
#allbots {
  .v-icon {
    line-height: 0 !important;
    height: 0 !important;
  }
  .select-page {
    .page {
      transition: transform 0.3s ease-out;
      .v-responsive .v-responsive__content {
        object-fit: cover;
        height: 120px;
      }

      &:hover {
        transform: translate(0, -5px);

        .page-image img {
          box-shadow: 0px 3px 5px #00000021;
        }
      }
    }
  }

  @media screen and (min-width: 768px) {
    .select-page .page .v-responsive .v-responsive__content {
      height: 185px;
    }
  }

  @media screen and (min-width: 820px) {
    .select-page .page .v-responsive .v-responsive__content {
      height: 197px;
    }
  }

  @media screen and (min-width: 1024px) {
    .select-page .page .v-responsive .v-responsive__content {
      height: 150px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/allbots/Account.vue